import React from 'react';
import Scroll from 'react-scroll';
import Select from 'react-select';

import Const from '../../util/Constants';
import RegEx from '../../util/RegEx';

class FieldMultiMainModel extends React.Component {
  
  constructor(props) {
    super(props);
    this.visible = props.field && props.field.visible === Const.True;
    this.editable = props.field && props.field.editable === Const.True;
    this.LabelName = props.field && props.field.label_name;
    this.regex = props.field && props.field.validate;
    this.Key = props.id;

    const values = props.value ? props.value: '';
    this.selections = props.options && props.options.filter(opt => 
      values.includes(Const.Opt+opt.value+Const.Opt));
    this.state = { selections: this.selections, inValid: {} };
  }

  onChange = (selections) => {
    let value  = '';
    for(let i = 0; i < selections.length; i++) { value = value + selections[i].value + '~'; }
    value = value !== '' ? '~' + value : '';
    let inValid = { };
    if(!RegEx.isDate(value, this.regex)) inValid[this.Key] = 'Invalid Data';
    this.props.onValueChange(this.Key, value);
    this.setState({ selections: selections, inValid: { ...inValid } });
  }

  render() {
    if(!this.visible || !this.editable) return null;
    
    let inValid = this.state.inValid;
    if(this.editable && RegEx.isKeyPresent(this.props.inValid, this.Key)) {
      inValid = this.props.inValid;
    }

    return (
      <div className="col">
        <div className={`form-group ${RegEx.class(inValid, this.Key)}`}>
          <Scroll.Element name={this.Key} />
          <label>{this.LabelName}</label> {RegEx.showError(inValid, this.Key)}
          <Select value={this.state.selections} onChange={this.onChange}
            options={this.props.options} isDisabled={!this.editable} isSearchable={true}
            isClearable={true} isMulti={true} />
        </div>
      </div>
    );
  }
}
export default FieldMultiMainModel;